import { render, staticRenderFns } from "./CatalogsDialogToggle.vue?vue&type=template&id=0e589ac0&"
import script from "./CatalogsDialogToggle.vue?vue&type=script&lang=js&"
export * from "./CatalogsDialogToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports